import { apiClient } from './client';

export type KnowledgeSnippetStatus = 'active' | 'archived';

export interface KnowledgeSnippet {
  id: number;
  title: string;
  content: string;
  status: KnowledgeSnippetStatus;
  expires_at: string | null;
  archived_at: string | null;
  created_by: number | null;
  creator_name: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface KnowledgeSnippetListParams {
  page?: number;
  per_page?: number;
  status?: KnowledgeSnippetStatus;
  search?: string;
  show_expired?: boolean;
}

export interface KnowledgeSnippetPayload {
  title: string;
  content: string;
  expires_at?: string | null;
}

export interface PaginatedKnowledgeSnippets {
  data: KnowledgeSnippet[];
  meta?: {
    current_page?: number;
    last_page?: number;
    per_page?: number;
    total?: number;
  };
}

export function listKnowledgeSnippets (params: KnowledgeSnippetListParams = {}) {
  return apiClient.get<PaginatedKnowledgeSnippets>('/loop-assistant/knowledge-snippets', { params });
}

export function getKnowledgeSnippet (id: number | string) {
  return apiClient.get<KnowledgeSnippet>(`/loop-assistant/knowledge-snippets/${id}`);
}

export function createKnowledgeSnippet (payload: KnowledgeSnippetPayload) {
  return apiClient.post<KnowledgeSnippet>('/loop-assistant/knowledge-snippets', payload);
}

export function updateKnowledgeSnippet (id: number | string, payload: KnowledgeSnippetPayload) {
  return apiClient.put<KnowledgeSnippet>(`/loop-assistant/knowledge-snippets/${id}`, payload);
}

export function archiveKnowledgeSnippet (id: number | string) {
  return apiClient.post<KnowledgeSnippet>(`/loop-assistant/knowledge-snippets/${id}/archive`);
}

export function unarchiveKnowledgeSnippet (id: number | string) {
  return apiClient.post<KnowledgeSnippet>(`/loop-assistant/knowledge-snippets/${id}/unarchive`);
}

export function deleteKnowledgeSnippet (id: number | string) {
  return apiClient.delete(`/loop-assistant/knowledge-snippets/${id}`);
}
